import { Calendar } from 'primereact/calendar';
import { useTranslation } from "react-i18next";
import "../item.css"

export const DateFieldItemForm = ({ field, changeValueCallback, itemForm, isDisabled }) => {
    const [t, i18n] = useTranslation();
    const currentLanguage = i18n.resolvedLanguage;

    const handleInputChange = (value) => {
        let isoValue = null;
        if (value) {
            // Ensure we send date at midnight (00:00:00) to avoid timezone issues
            const date = new Date(value);
            date.setHours(0, 0, 0, 0);
            isoValue = date.toISOString();
        }
        changeValueCallback({
            ...itemForm,
            form: {
                ...itemForm.form,
                [field.Code]: isoValue
            }
        });
    }

    return (
        <div style={{ marginTop: "7px" }}>
            <label style={{ fontSize: '0.9rem', color: '#666', marginBottom: '4px', display: 'block' }}>
                {field.Captions[currentLanguage]?.length > 0 ? `${field.Captions[currentLanguage]}${field.IsMandatory ? '*' : ''}` : `${field.Code}${field.IsMandatory ? '*' : ''}`}
            </label>
            <Calendar
                value={itemForm.form[field.Code] ? new Date(itemForm.form[field.Code]) : null}
                onChange={(e) => handleInputChange(e.value)}
                dateFormat="dd/mm/yy"
                disabled={isDisabled}
                style={{ width: "100%" }}
            />
        </div>
    )
}